import { CONFIDENCE_PERCENTILE_SLICES } from './config';
import type { LearningConfidenceResult } from './types';

const LOW_PERCENTILE_WEIGHTS: Record<number, number> = {
    10: 10,
    20: 9,
    30: 8,
    40: 7,
    50: 6,
    60: 5,
    70: 4,
    80: 3,
    90: 2,
    100: 1,
};

/**
 * Pontua presets priorizando acertos maiores nos menores percentuais do ranking.
 * Quanto menor o percentil (Top 10%, 20%...), maior o peso na pontuação.
 */
export const scorePresetForLowPercentiles = (
    confidence: LearningConfidenceResult
): number => {
    let score = 0;

    confidence.percentileSlices.forEach((slice) => {
        const weight = LOW_PERCENTILE_WEIGHTS[slice.percentile] ?? 1;
        score += weight * slice.avgHits;

        if (slice.beatsRandom) {
            score += weight * 0.75;
        }

        score += weight * (slice.acertividade / 100) * 0.5;
    });

    if (confidence.minPercentileGood) {
        const lowPercentileBonus = (100 - confidence.minPercentileGood.percentile) / 10;
        score += lowPercentileBonus * confidence.minPercentileGood.avgHits * 3;
    }

    CONFIDENCE_PERCENTILE_SLICES.filter((percentile) => percentile <= 30).forEach((percentile) => {
        const slice = confidence.percentileSlices.find((item) => item.percentile === percentile);
        if (slice) {
            score += slice.maxHits * (LOW_PERCENTILE_WEIGHTS[percentile] ?? 1);
        }
    });

    return score;
};
